import api from "./Api";

export const DEFAULT_PRINT_SLOTS = [
  { field_name: "qty_4pm", label: "4 PM", sort_order: 10, is_active: 1 },
  { field_name: "qty_6pm", label: "6 PM", sort_order: 20, is_active: 1 },
  { field_name: "qty_9am", label: "9 AM", sort_order: 30, is_active: 1 },
  { field_name: "qty_12pm", label: "12 PM", sort_order: 40, is_active: 1 },
  { field_name: "qty_2pm", label: "2 PM", sort_order: 50, is_active: 1 },
];

export const DEFAULT_GRAPH_GROUPS = [
  { value: "main_account", label: "Platform / Account", sort_order: 10, is_active: 1 },
  { value: "account_courier", label: "Platform / Account / Courier", sort_order: 20, is_active: 1 },
  { value: "platform", label: "Platform", sort_order: 30, is_active: 1 },
  { value: "courier", label: "Courier", sort_order: 40, is_active: 1 },
  { value: "operational", label: "Operational Account", sort_order: 50, is_active: 1 },
];

export const DEFAULT_GRAPH_COLORS = [
  "#4dc9f6", "#f67019", "#f53794", "#537bc4", "#acc236",
  "#166a8f", "#58595b", "#8549ba", "#00a950", "#ff6f61",
  "#ffcd56", "#c9cbcf", "#36a2eb", "#ff6384", "#9966ff",
  "#4bc0c0", "#ff9f40", "#8bc34a", "#00acc1", "#e91e63",
  "#795548", "#607d8b", "#7e57c2", "#26a69a", "#d4e157",
  "#ec407a", "#5c6bc0", "#66bb6a", "#ffa726", "#8d6e63",
  "#29b6f6", "#ab47bc", "#ef5350", "#9ccc65", "#ff7043",
  "#26c6da", "#d81b60", "#3949ab", "#00897b", "#c0ca33",
];

export function graphColorForIndex(index) {
  if (index < DEFAULT_GRAPH_COLORS.length) return DEFAULT_GRAPH_COLORS[index];

  const generatedIndex = index - DEFAULT_GRAPH_COLORS.length;
  const hue = (generatedIndex * 137.508 + 23) % 360;
  const saturation = 62 + (generatedIndex % 4) * 7;
  const lightness = 42 + (generatedIndex % 3) * 8;
  return `hsl(${hue.toFixed(1)}, ${saturation}%, ${lightness}%)`;
}

export function buildGraphColorMap(keys = []) {
  return keys.reduce((map, key, index) => {
    map[key] = graphColorForIndex(index);
    return map;
  }, {});
}

export async function fetchAppConfig() {
  try {
    const res = await api.get("/api/app-config");
    return {
      print_slots: res.data?.print_slots?.length ? res.data.print_slots : DEFAULT_PRINT_SLOTS,
      graph_groups: res.data?.graph_groups?.length ? res.data.graph_groups : DEFAULT_GRAPH_GROUPS,
    };
  } catch (error) {
    console.warn("Failed to load app config, using defaults:", error.message);
    return {
      print_slots: DEFAULT_PRINT_SLOTS,
      graph_groups: DEFAULT_GRAPH_GROUPS,
    };
  }
}

export async function fetchReportConfig() {
  try {
    const res = await api.get("/api/report-config");
    return {
      groups: res.data?.groups?.length ? res.data.groups : DEFAULT_GRAPH_GROUPS,
    };
  } catch (error) {
    console.warn("Failed to load report config, using defaults:", error.message);
    return {
      groups: DEFAULT_GRAPH_GROUPS,
    };
  }
}
